import { supabase } from "../lib/supabase";
import { useState } from "react";
import React from "react";
// Add UnsubscribePage here
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

export const UnsubscribePage: React.FC = () => {
  const { email } = useParams<{ email: string }>();
  const [status, setStatus] = useState<"loading" | "success" | "notfound" | "error">("loading");
  const navigate = useNavigate();
  
  useEffect(() => {
    const unsubscribe = async () => {
      console.log("Unsubscribing email:", email);
      if (!email) {
        setStatus("error");
        return;
      }
      const { data, error } = await supabase
        .from("users")
        .select("id, marketing_consent")
        .eq("email", email)
        .single();

      if (error || !data) {
        setStatus("notfound");
        return;
      }

      const { error: updateError } = await supabase
        .from("users")
        .update({ marketing_consent: false })
        .eq("id", data.id);

      if (updateError) {
        setStatus("error");
      } else {
        setStatus("success");
      }
    };

    unsubscribe();
  }, [email]);

  useEffect(() => {
    if (status === "success" || status === "notfound" || status === "error") {
      const timer = setTimeout(() => {
        navigate("/");
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [status, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="bg-white p-8 rounded shadow text-center max-w-md">
        {status === "loading" && <p>Procesando tu solicitud...</p>}
        {status === "success" && (
          <>
            <h2 className="text-xl font-bold mb-2">¡Te has dado de baja!</h2>
            <p className="text-green-600">Has sido dado de baja exitosamente de los correos de marketing.</p>
          </>
        )}
        {status === "notfound" && (
          <>
            <h2 className="text-xl font-bold mb-2">Correo no encontrado</h2>
            <p className="text-red-600">Lo sentimos, no pudimos encontrar tu correo en nuestro sistema.</p>
          </>
        )}
        {status === "error" && (
          <>
            <h2 className="text-xl font-bold mb-2">Error</h2>
            <p className="text-red-600">Algo salió mal. Por favor, inténtalo de nuevo más tarde.</p>
          </>
        )}
      </div>
    </div>
  );
};